import React from 'react';
import styled from 'styled-components';
import { SdiFile, styles } from '@sdir/sds';
import { AttachmentResult } from '@sdir/httpclient/lib/clients/aps/application';

interface AttachmentsButtonProps {
  onClick: () => void;
  attachments: AttachmentResult[];
  buttonText?: string;
  className?: string;
  endIcon?: any;
  showFileIcon?: boolean;
}

export const AttachmentsButton: React.FC<AttachmentsButtonProps> = ({
  onClick,
  attachments,
  className,
  endIcon,
  buttonText,
  showFileIcon = true,
}) => {
  return (
    <Button className={className} type="button" onClick={onClick}>
      {showFileIcon && (
        <div className="file-btn-icon">
          <SdiFile size="s" height="1em" color={styles.colors.primary} />
        </div>
      )}
      <div className="file-btn-text">
        {buttonText ? (
          <>{buttonText}</>
        ) : (
          <>
            {attachments[0]?.blobName}
            {attachments.length > 1 ? ` (+${attachments.length - 1})` : ''}
          </>
        )}
      </div>
      {endIcon && <div className="file-btn-end">{endIcon}</div>}
    </Button>
  );
};

const Button = styled.button`
  display: flex;
  align-items: center;
  border: none;
  box-shadow: none;
  border-radius: 0.5rem;
  background: #e5ebf080;
  color: ${styles.colors.primary};
  padding: 0.5rem 2rem;
  min-height: 6rem;
  text-align: start;

  .file-btn-icon,
  .file-btn-edit {
    flex: 0 0;
    line-height: 1em;
  }

  .file-btn-text {
    flex: 1 1;
    padding: 0 3rem 0 1.5rem;
    font-family: ${styles.fonts.stfBook};
    display: flex;
    column-gap: 2rem;
    flex-wrap: wrap;
    line-height: 1em;
  }

  &:hover,
  &:focus {
    background: ${styles.colors.primary10};
  }

  &.error,
  &.valid,
  &.warning {
    width: 100%;
    color: #000000;

    .file-btn-text {
      justify-content: center;
    }
  }

  &.error {
    background-color: ${styles.colors.alert.errorDark};

    &:hover,
    &:focus {
      background-color: ${styles.colors.alert.errorDark}dd;
    }
  }

  &.valid {
    background-color: ${styles.colors.alert.successDark};

    &:hover,
    &:focus {
      background-color: ${styles.colors.alert.successDark}dd;
    }
  }

  &.warning {
    background-color: ${styles.colors.alert.warningDark};

    &:hover,
    &:focus {
      background-color: ${styles.colors.alert.warningDark}dd;
    }
  }
`;
